import { ThunkResult } from '../../store'
import itemApi from '../../apis/item.api'
import itemService from '../../services/item.service'
import { replaceResult, replaceResultData } from './Items.slice'

export function paginate (): ThunkResult<void> {
  return (dispatch, getState) => {
    const { page, limit, search } = getState().items
    const params = { page, limit, search }
    itemApi.paginate(params, paginate => {
      if (!paginate) return
      dispatch(replaceResult(paginate))
    })
  }
}

export function deleteItem (id: number): ThunkResult<void> {
  return (dispatch, getState) => {
    itemApi.delete(id, item => {
      if (!item) return
      const { result } = getState().items
      const data = itemService.delete(result.data, id)
      dispatch(replaceResultData(data))
    })
  }
}
